import React from "react";
import moreImg from "../../assets/images/landing-page/moreImg.png";
import "./styles.css";

const LeaseConfidenceSection = () => {
  return (
    <section
      className="lease-confidence"
      style={{ backgroundImage: `url(${moreImg})` }}
    >
      <div className="container">
        <div className="row">
          <div>
            <h2 className="text-white fw-600 confidence-title">
              Get your<span className="text-primary"> property</span> seen by
              the <span className="text-primary">right people</span>
              <br />
            </h2>
          </div>
        </div>
      </div>

      <div className="confidence-tags-wrapper">
        <div className="container">
          <div className="confidence-tags">
            <div className="confidence-tag">
              <i className="fa fa-check bg-primary text-black rounded-5 fa-solid p-1" />
              <span className="tag-text">Verified properties</span>
            </div>

            <div className="confidence-tag">
              <i className="fa fa-check bg-primary text-black rounded-5 fa-solid p-1" />

              <span className="tag-text">Real hosts</span>
            </div>

            <div className="confidence-tag">
              <i className="fa fa-check bg-primary text-black rounded-5 fa-solid p-1" />

              <span className="tag-text">3D Tours</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeaseConfidenceSection;
